import { isValid, fromUnixTime, getUnixTime } from 'date-fns';

import { getCookie, setCookie } from '../utils/cookie-handler';
import { getCookieDomain } from '../utils/environment';

const eventHistoryCookieName = '_bo_event_history';

function getEventHistory() {
    const raw = getCookie(eventHistoryCookieName);

    if (!raw) {
        return [];
    }

    try {
        return JSON.parse(raw);
    } catch {
        // malformed cookie → reset to empty
        setEvenHistory([]);
        return [];
    }
}

function setEvenHistory(list) {
    // 1 year expiry
    const expiry = new Date();
    expiry.setFullYear(expiry.getFullYear() + 1);

    setCookie(eventHistoryCookieName, JSON.stringify(list), {
        domain: getCookieDomain(),
        path: '/',
        expires: expiry,
        secure: true,
    });
}

export default function () {
    if (('__lap_event' in window) === false) {
        return;
    }

    const { id, title, url } = window.__lap_event;

    let eventHistory = getEventHistory();

    eventHistory = eventHistory.filter(event => {
        return event.id !== id;
    });

    eventHistory.push({
        id,
        title,
        url: new URL(url, window.location.href).href,
        visited: getUnixTime(new Date()),
    });

    if (eventHistory.length > 5) {
        eventHistory = eventHistory.slice(-5);
    }

    setEvenHistory(eventHistory);
}
